import { render, staticRenderFns } from "./ChatDetail.vue?vue&type=template&id=5cb2a393"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports